<template>
  <div id="box-configurator">
    <div class="inset-text" :class="color">{{text}}</div>
    <img class="box" src="../assets/blue-box.jpg" alt="Blue Box" />
    <div class="config">
      <md-field>
        <label>Text</label>
        <md-input v-model="text"></md-input>
      </md-field>
      <md-field>
        <label for="color">Color</label>
        <md-select v-model="color" name="color" id="color">
          <md-option value="natural">Natural</md-option>
          <md-option value="gold">Gold</md-option>
          <md-option value="silver">Silver</md-option>
        </md-select>
      </md-field>
    </div>
  </div>
</template>

<script>
export default {
  name: "BoxConfigurator",
  data: () => {
    return {
      text: "HAxCT",
      color: "natural"
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#box-configurator {
  width: 300px;
  margin: 0 auto;
}
.config {
  width: 300px;
}
.natural {
  color: rgba(93, 199, 189, 0.6);
}
.gold {
  color: rgba(255, 225, 0, 0.75);
}
.silver {
  color: rgba(255, 255, 255, 0.8);
}
.inset-text {
  font-family: "PT Serif", serif;
  font-weight: 100;
  font-size: 18pt;
  line-height: 150px;
  background-size: 200%;
  text-shadow: -1px 1px 1px #81d8d0, 0 0 0 #000;
  transform: rotateX(31deg) rotateZ(-31deg) translateY(58px) translateX(50px);
  display: inline-block;
  width: 157px;
  height: 160px;
  text-align: center;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Don't show shadows when selecting text */
::-moz-selection {
  background: #5af;
  color: #fff;
  text-shadow: none;
}

::selection {
  background: #5af;
  color: #fff;
  text-shadow: none;
}

img.box {
  height: 300px;
  margin-top: -160px;
}
</style>
